import React, { Component } from 'react';
import ActiveSelectableButton from './ActiveSelectableButton';

export default class GeneralLargeBackButtonComponent extends Component {
	static defaultProps = {
		showBackButton: true,
		block: true
	};

	render() {
		const { onClick, text, showBackButton, children, disabled, block, modern } = this.props;
		if(!showBackButton && !children) {
			return null;
		}
		return (
			<div className='active_selectables'>
				{showBackButton &&
				<ActiveSelectableButton
					modern={modern}
					block={!this.props.children && block}
					onClick={onClick}
					disabled={disabled}
				>
					{text || 'Back'}
				</ActiveSelectableButton>
				}
				{children}
			</div>
		);
	}
}